export const INTRO = 'INTRO'
export const CIRCLE = 'CIRCLE'
export const OPENED = 'OPENED'
